export const swiperTopClients = () => {
  const el = document.querySelector(".js-swiper-top-clients");
  if (!el) return;

  new Swiper(el, {
    slidesPerView: "auto",
    spaceBetween: 12,
    loop: true,
    speed: 4000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        spaceBetween: 24,
      },
    },
    allowTouchMove: false,
  });
};
